import { Box, Button, Chip, CircularProgress, Paper, Stack, Typography } from '@mui/material';
import React, { useEffect } from 'react';
import { Icon } from '@iconify/react';
import { ReactTyped } from 'react-typed';
import MotionWrapper from '../../../components/MotionWrapper';

function calculatePercentage(part, total) {
  if (total === 0) {
    return 0;
  }
  return Number((part / total) * 100).toFixed(2);
}
const DashboardCards = ({ data, handleClick, selected }) => {
  const [status, setStatus] = React.useState(0);

  useEffect(() => {
    if (data) {
      const percentage = calculatePercentage(data?.amountCollected, data?.amountToCollect);
      const fixed = Number(percentage).toFixed(2);
      setStatus(fixed);
    }
  }, [data]);
  return (
    <Box width={'100%'}>
      <Paper
        elevation={3}
        sx={{
          background: '#af91f09c',
          borderRadius: 2.5,
          transition: 'transform 0.3s ease-in-out',
          '&:hover': {
            transform: 'scale(1.05)',
          },
        }}
      >
        <Box
          padding={1}
          sx={{
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <Stack direction={'column'}>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: 50,
                width: 50,
                borderRadius: '50%',
                ml: 3,
                background: '#6227df73',
                backdropFilter: 'blur(12px)',
                WebkitBackdropFilter: 'blur(12px)',
                // border: "1px solid rgb(30, 28, 93)",
                boxShadow: '0 4px 10px rgba(96, 20, 226, 0.95)',
              }}
            >
              <Icon style={{ color: 'white' }} icon="hugeicons:course" width="24" height="24" />
            </Box>

            <Typography
              sx={{
                color: 'black',
                fontWeight: 'bolder',
                fontSize: 18,
                ml: 1,
                pt: 1,
              }}
            >
              <ReactTyped strings={[`${data.project_name}`, `${data.project_name}`]} typeSpeed={30} backSpeed={30} />
            </Typography>
          </Stack>
        </Box>

        <Box sx={{ display: 'flex', justifyContent: 'space-around' }}>
          {/* <Stack direction={"row"} spacing={4}> */}
          {/* <Box>
            <Box sx={{ position: "relative", display: "inline-flex" }}>
              <MotionWrapper delay={0.5} directions={"top"}>
                <CircularProgress
                  color={
                    status <= 20
                      ? "error"
                      : status < 80
                      ? "warning"
                      : status >= 80
                      ? "success"
                      : "primary"
                  }
                  variant="determinate"
                  size={80}
                  value={calculatePercentage(
                    data?.amountCollected,
                    data?.amountToCollect
                  )}
                />
              </MotionWrapper>

              <Box
                sx={{
                  top: 0,
                  left: 0,
                  bottom: 0,
                  right: 0,
                  position: "absolute",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Typography
                  variant="caption"
                  component="div"
                  sx={{ color: "text.secondary" }}
                >
                  {`${calculatePercentage(
                    data?.amountCollected,
                    data?.amountToCollect
                  )}%`}
                </Typography>
              </Box>
            </Box>
            <Box>
              <Typography
                variant="caption"
                component="div"
                sx={{ color: "black" }}
              >
                Completion Status
              </Typography>
            </Box>
          </Box> */}
          <Box>
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              <Stack direction={'column'} spacing={1}>
                <Chip
                  size="small"
                  variant="outlined"
                  color="primary"
                  sx={{ height: 20 }}
                  label={<Typography sx={{ fontSize: 10 }}>Current Month Fee To Collect</Typography>}
                />
                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                  <Typography sx={{ color: 'black' }} variant="h6">
                    {new Intl.NumberFormat('en-US').format(data.collectionForCurrentMonth)}
                  </Typography>
                </Box>
              </Stack>
            </Box>

            <Box sx={{ pb: 2, display: 'flex', justifyContent: 'center' }}>
              <Stack direction={'column'} spacing={1} pt={1}>
                <Chip
                  size="small"
                  variant="outlined"
                  color="primary"
                  sx={{ height: 20 }}
                  label={<Typography sx={{ fontSize: 10 }}>Collected Fee</Typography>}
                />
                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                  <Typography sx={{ color: 'black' }} variant="h6">
                    {new Intl.NumberFormat('en-US').format(data.amountCollected)}
                  </Typography>
                </Box>
              </Stack>
            </Box>
            {/* -------------------------- */}

            <Box sx={{ pb: 2, display: 'flex', justifyContent: 'center' }}>
              <Stack direction={'column'} spacing={1} pt={1}>
                <Chip
                  size="small"
                  variant="outlined"
                  color="primary"
                  sx={{ height: 20 }}
                  label={<Typography sx={{ fontSize: 10 }}>Previous Month Pending</Typography>}
                />
                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                  <Typography sx={{ color: 'black' }} variant="h6">
                    {new Intl.NumberFormat('en-US').format(data.pendingFee)}
                  </Typography>
                </Box>
              </Stack>
            </Box>
          </Box>
          {/* </Stack> */}
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', p: 1 }}>
          <Button onClick={handleClick} sx={{ backgroundColor: 'white', color: 'black', borderRadius: 2 }} size="small">
            <Icon icon="material-symbols-light:drag-click" width="24" height="24" />
          </Button>
        </Box>
        {selected && data && selected.project_id === data.project_id ? (
          <MotionWrapper directions={'bottom'} delay={0.5}>
            <Box sx={{ display: 'flex', justifyContent: 'center', p: 2 }}>
              <Box
                sx={{
                  height: 10,
                  width: 40,
                  backgroundColor: 'rgba(0, 255, 0, 0.6)',
                  borderRadius: 3,
                  boxShadow: '0 0 7px 4px rgba(0, 255, 0, 0.8)',
                }}
              ></Box>
            </Box>
          </MotionWrapper>
        ) : null}
      </Paper>
    </Box>
  );
};

export default DashboardCards;
